import { createContext } from 'react';

import type { DynamicContextValue } from './types';

/* 
  This context must be imported using the client-site-chrome-ui alias  
  i.e. client-site-chrome-ui/context/DynamicContext/context
  to ensure it is always resolved from the same location by yarn PNP
  otherwise an error can be thrown that the context is not defined 
  i.e.'useSiteChromeDynamicContext must be used within a SiteChromeDynamicContextProvider'
*/

export const SiteChromeDynamicContext = createContext<DynamicContextValue | undefined>(undefined);
